import type { SailingFromPackages } from '@/infra/types/voyageInfo/sailing';

import { getBarTabText } from '@/features/promo/lib/getBarTabText';
import { selectMerchandisingBannerDetails } from '@/features/promoBanners/selectors';
import { useAppSelector } from '@/store';

import { useGetBarTabAmount } from '../lib/useGetBarTabAmount';
import { useIsPromoActive } from '../lib/useIsPromoActive';

import styles from './FullDetailsBarTab.module.scss';

export type TProps = {
  duration: number;
  sailingList: SailingFromPackages[];
};

const BarTabBadge = ({ duration, sailingList }: TProps) => {
  const isSale = useIsPromoActive('barTabHeroImage', sailingList);
  const { fullCruiseDetailsHeroImageText } = useAppSelector(selectMerchandisingBannerDetails) || {};

  const barTabAmount = useGetBarTabAmount(duration);
  const barTabText = getBarTabText(fullCruiseDetailsHeroImageText, barTabAmount);

  if (!isSale || !barTabText) return null;

  return (
    <div className={styles.root}>
      <p className={styles.text}>{barTabText}</p>
    </div>
  );
};

export default BarTabBadge;
